<div *ngIf="!isRemoved">
    <h2 style="margin-bottom: 1.5px; text-align: center;">
        Are you sure you want to
    </h2>
    <h2 style="margin-top: 0; text-align: center;">
        remove this version?
    </h2>
    <div style="text-align: center;">
        <span style="color: #757575;">This cannot be undone!</span>
    </div>
    <div style="display: flex; justify-content: center; align-items: center; gap: 15px; margin-top: 45px; margin-bottom: 12px;">
        <!-- V2-11: `outline`, not `secondary` — secondary paints a near-black
             label/border master never had; every other dismiss button in the
             app uses the orange outline treatment (see confirm-dialog). -->
        <button class="hide-on-mobile" id="cancel" type="button" vng-button variant="outline" aria-label="cancel" tabindex="-1" (click)="close()">
            Cancel
        </button>

        <button class="hide-on-mobile" id="deleteShortcut" type="button" vng-button variant="primary" aria-label="delete" tabindex="-1" (click)="removeVersion()">
            Remove Version
        </button>
    </div>
</div>
<div *ngIf="isRemoved">
    <div style="text-align: center;">
        <img src="../../../../../assets/images/success.png" alt="">
    </div>
    <p style="text-align: center; font-size: 20px; line-height: 27px;">Version Removed!</p>
    <div style="text-align: center;">
        <span style="color: #757575;">The selected version has been successfully</span>
    </div>
    <div style="text-align: center;">
        <span style="color: #757575;">removed from the version history.</span>
    </div>
    <div style="display: flex; justify-content: center; align-items: center; margin-top: 30px; margin-bottom: 15px;">
        <button type="button" vng-button variant="primary" style="width: 88%; height: 40px;" (click)="close()">
          <span style="font-size: 15; line-height: 20px;">Go Back</span>
        </button>
    </div>
</div>